import { Button } from '@kanda-libs/ks-design-library';

import useApplyButton from './useApplyButton';

interface ApplyButtonProps {
  interest: string;
  isLoading: boolean;
  isSubmitting: boolean;
  selectNewRate?: boolean;
  disabled?: boolean;
}

const ApplyButton = ({
  interest,
  isLoading,
  isSubmitting,
  selectNewRate = false,
  disabled = false,
}: ApplyButtonProps) => {
  const { label, accepted } = useApplyButton(selectNewRate);

  return (
    <div className="flex flex-col mt-2 mb-8 md:mt-6">
      <Button.Text
        label={label}
        submit
        variant="gradient"
        icon="arrow-right"
        id={`plan-${interest}-submit`}
        className="w-full"
        disabled={isLoading || isSubmitting || disabled || !accepted}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ApplyButton;
